import React from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, GlobeIcon, ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
export function WirelessPhonePage({
  onNavigate
}: {
  onNavigate: (page: string) => void;
}) {
  return <div className="pt-20" data-id="element-2470">
      <section className="bg-slate-900 py-24 relative overflow-hidden" data-id="element-2471">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-2472"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2473">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-2474">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-2475">
              Wireless <span className="text-accent" data-id="element-2476">Phone Solutions</span>
            </h1>
            <p className="text-xl text-slate-300 mb-8" data-id="element-2477">
              Empower your mobile workforce with enterprise-grade wireless phone
              systems and global connectivity.
            </p>
            <button onClick={() => onNavigate('contact')} className="bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center gap-2" data-id="element-2478">
              View Plans
              <ArrowRightIcon className="w-5 h-5" data-id="element-2479" />
            </button>
          </motion.div>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-2480">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2481">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-2482">
            {[{
            icon: SmartphoneIcon,
            title: 'Mobile First',
            desc: 'Seamlessly integrate mobile devices into your corporate phone system with advanced features.'
          }, {
            icon: GlobeIcon,
            title: 'Global Roaming',
            desc: 'Stay connected wherever business takes you with our extensive international coverage.'
          }, {
            icon: ShieldCheckIcon,
            title: 'Unified Management',
            desc: 'Manage all your wireless lines and devices from a single, intuitive administrative portal.'
          }].map((feature, i) => <div key={i} className="p-8 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-2483">
                <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center mb-6" data-id="element-2484">
                  <feature.icon className="w-6 h-6 text-accent" data-id="element-2485" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2486">
                  {feature.title}
                </h3>
                <p className="text-slate-600" data-id="element-2487">{feature.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}